export const createCartMutation = `
    mutation createCart($lines: [CartLineInput!]!, $countryCode: CountryCode) {
  cartCreate(
    input: {
      buyerIdentity: {
        countryCode: $countryCode
      }
      lines: $lines
    }
  ) {
    cart {
      id
      checkoutUrl
      createdAt
      updatedAt
      lines(first: 50) {
        edges {
          node {
            id
            attributes {
                key
                value
            }
            quantity
            merchandise {
              ... on ProductVariant {
              id
              price {
                amount
                currencyCode
              }
              title
              availableForSale
              compareAtPrice {
                  amount,
                  currencyCode
                }
              product {
                title
                tags
                availableForSale
                handle
                featuredImage {
                  url
                  altText
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
              }
              }
            }
          }
        }
      }
      buyerIdentity {
        deliveryAddressPreferences {
          __typename
        }
        countryCode
      }
      attributes {
        key
        value
      }
      # The estimated total cost of all merchandise that the customer will pay at checkout.
      cost {
        totalAmount {
          amount
          currencyCode
        }
        # The estimated amount, before taxes and discounts, for the customer to pay at checkout.
        subtotalAmount {
          amount
          currencyCode
        }
        # The estimated tax amount for the customer to pay at checkout.
        totalTaxAmount {
          amount
          currencyCode
        }
        # The estimated duty amount for the customer to pay at checkout.
        totalDutyAmount {
          amount
          currencyCode
        }
      }
    }
  }
}
    `
